import { Grid } from '@mui/material';
import DashboardUyeCard from '../DashboardUyeCard';
import DashboardUserInfoMeetingsCard from '../DashboardUserInfoMeetingsCard';

function DashboardUyeOnlyDesign({ countUserInfo }) {
    return (
        <Grid container spacing={1} direction="row">
            <Grid item xs={12} md={12} lg={9}>
                <DashboardUyeCard countUserInfo={countUserInfo}></DashboardUyeCard>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                <DashboardUserInfoMeetingsCard countList={countUserInfo} />
            </Grid>
        </Grid>
    );
}

export default DashboardUyeOnlyDesign; 